import { useState } from "react";
import { BlogPaginationProps } from "@/components/pages/blog/BlogPagination";

export const useClientPagination = () => {
  const [paginationPage, setPaginationPage] = useState(1);
  const [paginationPageCount, setPaginationPageCount] = useState(1);

  const pagination: BlogPaginationProps = {
    page: paginationPage,
    pageCount: paginationPageCount,
    type: "client",
    controls: {
      setPage: setPaginationPage,
      setPageCount: setPaginationPageCount,
    },
  };

  return pagination;
};
